import { WithCallback } from '@frontegg/redux-store/interfaces';
import { ISwitchTenant, ITenantsResponseV2 } from '@frontegg/rest-api';
import { ThemeOptions } from '@mui/material';

export const ADMIN_PORTAL_QP = 'admin-portal';
export const ENTER_MFA_PARAM = 'enter_mfa';

export enum AppType {
  Portal = 'portal',
  Teams = 'teams',
  Backstage = 'backstage',
}

export interface User {
  id: string;
  email: string;
  name: string;
  roles?: { name: string }[];
  app: AppType;
  profilePictureUrl?: string;
  tenantId: string;
  withUser?: boolean;
  withLogo?: boolean;
  isDarkSidebar?: boolean;
}

export interface AuthData {
  user: User;
  accessToken: string;
  tenants: ITenantsResponseV2[];
  isMfaPassed?: boolean;
  isMfaEnrolled?: boolean;
}

export interface AuthContextProps extends AuthData {
  switchTenant: (payload: WithCallback<ISwitchTenant>) => void;
  showAdminPortal: () => void;
  onSetUpMfa: () => void;
  onEnterMfa: () => void;
}

export const MessageType = {
  READY: 'READY',
  AUTHENTICATE: 'AUTHENTICATE',
  THEME_UPDATE: 'THEME_UPDATE',
  THEME_READY: 'THEME_READY',
} as const;

export type MessageType = (typeof MessageType)[keyof typeof MessageType];

export interface IframeAuth {
  token: string;
  isFetched: boolean;
  isFetching: boolean;
  error?: string;
}

export interface IframeMessage {
  type: MessageType;
  message?: string;
  auth?: IframeAuth;
  theme?: ThemeOptions;
}
